import React, { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";
import { useParams, useNavigate } from "react-router-dom";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import {
  module1,
  module2,
  module3,
  module4,
  module5,
  module6,
} from "../data/tokenizacionProyecto/proyectObject";

const SIDEBAR_WIDTH = 300;

const COLOR_BG = "#02396d";
const COLOR_ACCENT = "#0151a2";
const COLOR_WHITE = "#fff";
const COLOR_ACTIVE = "#0151a2";
const COLOR_SHADOW = "0 8px 24px 0 rgba(40,80,120,0.10)";

const ExpandableImage = ({ src, alt }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (e) => {
    e.stopPropagation();
    setIsOpen(true);
  };

  const handleClose = (e) => {
    e.stopPropagation();
    setIsOpen(false);
  };

  return (
    <>
      <img
        src={src}
        alt={alt}
        style={{
          width: "90%",
          maxWidth: "100%",
          margin: "24px auto",
          display: "block",
          borderRadius: 12,
          boxShadow: "0 2px 8px 0 rgba(1,81,162,0.10)",
          background: "#fff",
          cursor: "zoom-in",
        }}
        onClick={handleOpen}
      />
      {isOpen && (
        <div
          onClick={handleClose}
          style={{
            position: "fixed",
            zIndex: 9999,
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "rgba(0,0,0,0.85)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{
              maxWidth: "92vw",
              maxHeight: "92vh",
              borderRadius: 16,
              boxShadow: "0 4px 32px 0 rgba(0,0,0,0.50)",
              background: "#fff",
            }}
            onClick={(e) => e.stopPropagation()} // No cerrar al click en imagen
          />
          <button
            onClick={handleClose}
            style={{
              position: "fixed",
              top: 28,
              right: 40,
              fontSize: 38,
              background: "none",
              border: "none",
              color: "#fff",
              cursor: "pointer",
              zIndex: 10000,
              fontWeight: "bold",
            }}
            aria-label="Cerrar"
          >
            ×
          </button>
        </div>
      )}
    </>
  );
};

const TokenViewerChartStyle = () => {
  const viewerRef = useRef(null);
  const { stepId } = useParams();
  const navigate = useNavigate();

  const allModules = [
    { name: "Módulo 1", items: module1 },
    { name: "Módulo 2", items: module2 },
    { name: "Módulo 3", items: module3 },
    { name: "Módulo 4", items: module4 },
    { name: "Módulo 5", items: module5 },
    { name: "Módulo 6", items: module6 },
  ];

  let counter = 1;
  const projectItems = allModules.flatMap((mod) =>
    mod.items.map((item) => ({
      id: `project-${counter++}`,
      title: item.title,
      value: item.value,
      module: mod.name,
      image: item.image,
    }))
  );

  const allProjects = [
    ...projectItems,
    {
      id: "upload-pdf",
      title: "Subir PDF",
      isPDF: true,
    },
  ];

  const currentIndex =
    allProjects.findIndex((proj) => proj.id === `project-${stepId}`) !== -1
      ? allProjects.findIndex((proj) => proj.id === `project-${stepId}`)
      : 0;

  const [selected, setSelected] = useState(allProjects[currentIndex]);
  const [openModules, setOpenModules] = useState(() =>
    allModules.reduce((acc, mod) => {
      acc[mod.name] = true;
      return acc;
    }, {})
  );

  const toggleModule = (name) => {
    setOpenModules((prev) => ({
      ...prev,
      [name]: !prev[name],
    }));
  };

  useEffect(() => {
    setSelected(allProjects[currentIndex]);
    if (viewerRef.current) {
      viewerRef.current.scrollTop = 0;
    }
    // eslint-disable-next-line
  }, [stepId]);

  const handleClick = (project, index) => {
    if (project.isPDF) {
      // aquí puedes mostrar el modal de PDF o la acción que desees
    } else {
      navigate(`/course/token-project-viewer/${index + 1}`);
    }
  };

  // Función para exportar a PDF
  const exportToPDF = async () => {
    if (!viewerRef.current) return;

    const element = viewerRef.current;

    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
      scrollY: -window.scrollY,
    });

    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF({
      orientation: "portrait",
      unit: "pt",
      format: "a4",
    });

    const pdfWidth = pdf.internal.pageSize.getWidth();
    const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    pdf.save("proyecto_tokenizado.pdf");
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        width: "100vw",
        backgroundColor: "#fff",
        fontFamily: "Segoe UI, sans-serif",
        overflow: "hidden",
      }}
    >
      

      {/* Sidebar */}
      <div
        style={{
          width: `${SIDEBAR_WIDTH}px`,
          minWidth: `${SIDEBAR_WIDTH}px`,
          maxWidth: `${SIDEBAR_WIDTH}px`,
          height: "100vh",
          background: COLOR_BG,
          color: COLOR_WHITE,
          padding: "1.5rem",
          overflowY: "auto",
          boxShadow: COLOR_SHADOW,
          position: "sticky",
          top: 0,
          left: 0,
          zIndex: 10,
        }}
      >
        <h2
          style={{
            fontSize: "1.2rem",
            fontWeight: "bold",
            marginBottom: "1rem",
            color: COLOR_WHITE,
            letterSpacing: "1px",
          }}
        >
          Proyecto
        </h2>

        <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
          {allModules.map((mod, modIndex) => (
            <li
              key={`mod-${modIndex}`}
              style={{
                background: "transparent",
                padding: "0.75rem 0.5rem",
                borderRadius: "0.5rem",
                marginBottom: "1rem",
              }}
            >
              <h3
                onClick={() => toggleModule(mod.name)}
                style={{
                  color: COLOR_ACCENT,
                  fontSize: "1rem",
                  marginBottom: "0.5rem",
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between",
                  userSelect: "none",
                }}
              >
                <span>{mod.name}</span>
                <span style={{ color: COLOR_WHITE, fontWeight: 300 }}>
                  {openModules[mod.name] ? "▼" : "►"}
                </span>
              </h3>

              {openModules[mod.name] &&
                mod.items.map((project, index) => {
                  const globalIndex = projectItems.findIndex(
                    (p) => p.title === project.title
                  );
                  const isActive = selected?.title === project.title;

                  return (
                    <li
                      key={project.title}
                      onClick={() =>
                        handleClick(projectItems[globalIndex], globalIndex)
                      }
                      style={{
                        padding: "10px",
                        marginBottom: "0.5rem",
                        borderRadius: "6px",
                        background: isActive ? COLOR_ACCENT : "transparent",
                        color: COLOR_WHITE,
                        cursor: "pointer",
                        transition: "background 0.3s",
                        fontWeight: isActive ? "bold" : "normal",
                        border: isActive
                          ? `1.5px solid ${COLOR_WHITE}`
                          : "1.5px solid transparent",
                        boxShadow: isActive
                          ? "0 2px 12px 0 rgba(1,81,162,0.10)"
                          : "none",
                      }}
                    >
                      Step {globalIndex + 1}
                    </li>
                  );
                })}
            </li>
          ))}

          {/* PDF uploader */}
          <li
  onClick={() => navigate("/course/token-project-viewer/pdf")}
  style={{
    padding: "10px",
    marginTop: "2rem",
    borderRadius: "8px",
    background: selected?.id === "upload-pdf" ? COLOR_ACCENT : COLOR_BG,
    color: COLOR_WHITE,
    cursor: "pointer",
    fontWeight: "bold",
    textAlign: "center",
    letterSpacing: "1px",
    border: selected?.id === "upload-pdf"
      ? `1.5px solid ${COLOR_WHITE}`
      : `1.5px solid ${COLOR_BG}`,
    boxShadow: selected?.id === "upload-pdf"
      ? "0 2px 12px 0 rgba(1,81,162,0.10)"
      : "none",
    transition: "background 0.3s, border 0.3s",
  }}
>
<button
  onClick={() => navigate("/course/token-project-viewer/pdf")}
  style={{
    width: "100%",
    padding: "12px 16px",
    backgroundColor: "#FF5722",  // color naranja fuerte para destacar
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    fontSize: "1rem",
    marginBottom: "1.5rem",
    boxShadow: "0 4px 8px rgba(255, 87, 34, 0.4)",
    transition: "background-color 0.3s ease",
  }}
  onMouseEnter={e => e.currentTarget.style.backgroundColor = "#E64A19"}
  onMouseLeave={e => e.currentTarget.style.backgroundColor = "#FF5722"}
>
  Subir PDF
</button>

</li>

        </ul>
      </div>

      {/* Viewer */}
      <div
        ref={viewerRef}
        style={{
          flexGrow: 1,
          padding: "10% 3rem 2rem 3rem", // Margen superior 10%
          overflowY: "auto",
          height: "100vh",
        }}
      >
        <h1
          style={{
            fontSize: "2rem",
            fontWeight: "bold",
            marginBottom: "1.5rem",
            color: "#1f2937",
          }}
        >
          {selected?.title}
        </h1>

        <div
          style={{
            fontSize: "1.05rem",
            lineHeight: "1.8rem",
            color: "#111827",
            textAlign: "justify",
          }}
        >
          <ReactMarkdown
            components={{
              img: ({ node, ...props }) => <ExpandableImage {...props} />,
              a: ({ node, ...props }) => (
                <a
                  {...props}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "#0151a2", textDecoration: "underline" }}
                  onClick={(e) => e.stopPropagation()}
                >
                  {props.children}
                </a>
              ),
              p: ({ node, ...props }) => (
                <p style={{ textAlign: "justify", marginBottom: "1rem" }} {...props} />
              ),
              li: ({ node, ...props }) => (
                <li style={{ marginBottom: "0.5rem", textAlign: "justify" }} {...props} />
              ),
              ul: ({ node, ...props }) => (
                <ul
                  style={{
                    paddingLeft: "1.5rem",
                    marginBottom: "1rem",
                    listStyleType: "disc",
                  }}
                  {...props}
                />
              ),
              ol: ({ node, ...props }) => (
                <ol
                  style={{
                    paddingLeft: "1.5rem",
                    marginBottom: "1rem",
                    listStyleType: "decimal",
                  }}
                  {...props}
                />
              ),
              h2: ({ node, ...props }) => (
                <h2
                  style={{
                    textAlign: "left",
                    fontSize: "1.5rem",
                    marginTop: "2rem",
                    marginBottom: "1rem",
                    fontWeight: "bold",
                  }}
                  {...props}
                />
              ),
              h3: ({ node, ...props }) => (
                <h3
                  style={{
                    textAlign: "left",
                    fontSize: "1.2rem",
                    marginTop: "1.5rem",
                    marginBottom: "0.75rem",
                    fontWeight: "bold",
                  }}
                  {...props}
                />
              ),

              // Aquí añado estilos para las tablas y sus celdas:
              table: ({ node, ...props }) => (
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    marginBottom: "1rem",
                  }}
                  {...props}
                />
              ),
              th: ({ node, ...props }) => (
                <th
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px 12px",
                    backgroundColor: "#0151a2",
                    color: "#fff",
                    textAlign: "left",
                  }}
                  {...props}
                />
              ),
              td: ({ node, ...props }) => (
                <td
                  style={{
                    border: "1px solid #ddd",
                    padding: "8px 12px",
                    textAlign: "left",
                  }}
                  {...props}
                />
              ),
              tr: ({ node, ...props }) => (
                <tr
                  style={{
                    backgroundColor: node.position?.start.line % 2 === 0 ? "#f9f9f9" : "white",
                  }}
                  {...props}
                />
              ),
            }}
          >
            {selected?.value}
          </ReactMarkdown>
        </div>
      </div>
    </div>
  );
};

export default TokenViewerChartStyle;
